module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_5010.83b1db4a.png";